module.exports = __webpack_public_path__ + "img/atendente.54cbb332.png";